module.exports = __webpack_public_path__ + "img/rank_3.a6457d8.png";